<template>
<transition name="fade">
    <!-- <div ref="div" class="div" style="height:500px;background:grey;"></div> -->
    <div ref="indexlist" class="index-list">
        <div class="tt" ref="tt"></div>
        <div ref="letter-box" class="letter-box">
            <p :class="{'active':isActive[index]}" v-for="(item,index) in selectionData" @click.stop="letterHandle(index)">
                <i>{{item.letter}}</i>
            </p>
        </div>
        <dl v-for="(item,index) in selectionData">
            <dt class="title">{{item.letter}}</dt>
            <dd v-for="(childe,cindex) in item.arr">{{childe}}</dd>
        </dl>
    </div>
</transition>
</template>
<style lang="scss" scoped>
@import "../../assets/styles/variables.scss";
.div{
    overflow: scroll;
}
html {
    height: 100%;
    background: red;
}
.tt {
    position: fixed;
    right: 0;
    top: 0;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background: gold;
    color: black;
}
.index-list {
    position: relative;
    .letter-box {
        font-size: r(12);
        z-index: 2;
        position: fixed;
        right: r(0);
        top: 50%;
        -webkit-transform: translateY(-50%);
        padding: r(5) 0;
        // background: rgba(0,0,0,0.1);
        p {
            padding: r(5) r(10);
            i {
                display: inline-block;
                font-style: normal;
                padding: r(5);
                width: r(10);
                height: r(10);
                line-height: r(10);
                text-align: center;
                border-radius: 100px;
            }
        }
        .active {
            color: #4a6fde;
            i {
                color: #ffffff;
                background: rgba(7, 155, 249,0.75);

            }
        }
    }
    dl {
        dt {
            color: #333;
            background: #f1f0f6;
            font-size: r(14);
            padding: r(5) r(10);
        }
        dd {
            font-size: r(16);
            color: #666666;
            padding: r(12) r(10);
            border-bottom: 1px solid #e5e5e5;
        }
    }

}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
</style>
<script>
export default {
    data() {
        return {
            sData: 'loading',
            isActive: [],
            aScreenTopArr:[],
            nowIndex: 0,
            timer: null,
            nowScrollTop:0,
            wsScrollTop:0,
            isClickLetter:true
        }
    },
    props: {
        selectionData: Array
    },
    mounted() {
        //获取某个div scrolltop     //pageYOffset
        // this.$refs['div'].addEventListener('scroll', () => {
        //     console.log(this.$refs['div'].scrollTop,'scroll');
        // }, false);
        // this.$refs['div'].scrollTo(0, 100)
        this.init()
        this.event()

    },
    methods: {
        init() {
            var indexList = this.$refs.indexlist;
            var aDl = indexList.getElementsByTagName('dl');
            this.clientHeight = document.documentElement.clientHeight
            this.containerHeight = indexList.offsetHeight
            this.maxDis = this.containerHeight - this.clientHeight

            this.nowScrollTop = document.documentElement.scrollTop + document.body.scrollTop;

            // if (this.nowScrollTop == 0 && this.wsScrollTop && this.wsScrollTop != 0) {
            //     this.nowScrollTop = this.wsScrollTop
            // }

            this.aScreenTopArr = []
            this.isActive = []
            for (var i = 0; i < aDl.length; i++) {
                this.isActive.push(false)
                this.aScreenTopArr.push(Math.round(aDl[i].getBoundingClientRect().top + this.nowScrollTop))
            }
            console.log(this.nowScrollTop, this.aScreenTopArr);

            this.activeHandle()

            // console.log(this.clientHeight, this.containerHeight, this.maxDis);
        },
        event() {
            //ios移动端刷新获取不到scrolltop 一直为0  scroll最后才会执行
            window.addEventListener('scroll', () => {
                this.nowScrollTop = document.documentElement.scrollTop + document.body.scrollTop;
                this.$refs['tt'].innerHTML = this.nowScrollTop;
                // console.log(this.nowScrollTop,'scroll');

                if(this.isClickLetter){
                    this.activeHandle()
                    if (this.nowScrollTop < 0) {
                        this.nowScrollTop = 0
                    } else if (this.nowScrollTop > this.maxDis) {
                        this.nowScrollTop = this.maxDis
                    }

                    if (this.nowScrollTop >= this.aScreenTopArr[this.nowIndex + 1]) {
                        this.isActive = [];
                        this.nowIndex++;
                        this.isActive[this.nowIndex] = true
                    }

                    if (this.nowScrollTop <= this.aScreenTopArr[this.nowIndex]) {
                        this.isActive = [];
                        this.nowIndex--;
                        this.nowIndex = this.nowIndex < 0 ? 0 : this.nowIndex;
                        this.isActive[this.nowIndex] = true
                    }

                }
                this.isClickLetter=true

            }, false);

            // document.body.addEventListener('touchstart', (e) => {
            //     var touch = e.changedTouches[0];
            //     this.downY = touch.clientY;
            //     this.lastY = 0;
            // }, false)
            //
            // document.body.addEventListener('touchmove', (e) => {
            //     var touch = e.changedTouches[0];
            //     this.nowScrollTop = document.documentElement.scrollTop + document.body.scrollTop;
            //     if (this.nowScrollTop < 0) {
            //         this.nowScrollTop = 0
            //     } else if (this.nowScrollTop > this.maxDis) {
            //         this.nowScrollTop = this.maxDis
            //     }
            //     // console.log(this.nowIndex, this.nowScrollTop);
            //
            //     // if (touch.clientY < this.lastY) {
            //     //     if (this.nowScrollTop > this.aScreenTopArr[this.nowIndex + 1]) {
            //     //         this.isActive = [];
            //     //         this.nowIndex++;
            //     //         this.isActive[this.nowIndex] = true
            //     //     }
            //     // } else if (touch.clientY > this.lastY) {
            //     //     if (this.nowScrollTop < this.aScreenTopArr[this.nowIndex]) {
            //     //         this.isActive = [];
            //     //         this.nowIndex--;
            //     //         this.isActive[this.nowIndex] = true
            //     //     }
            //     // }
            //
            //     this.lastY = touch.clientY
            //
            // }, false)
            //
            // document.body.addEventListener('touchend', (e) => {
            //     var touch = e.changedTouches[0];
            //     // clearInterval(this.timer)
            //     // this.timer = setInterval(() => {
            //     //     // console.log(document.documentElement.scrollTop)
            //     //     this.nowScrollTop = document.documentElement.scrollTop + document.body.scrollTop;
            //     //     if (this.nowScrollTop < 0) {
            //     //         this.nowScrollTop = 0
            //     //     } else if (this.nowScrollTop > this.maxDis) {
            //     //         this.nowScrollTop = this.maxDis
            //     //     }
            //     //
            //     //     // this.$refs['tt'].innerHTML = this.nowScrollTop
            //     //
            //     //     if (touch.clientY < this.downY) {
            //     //         if (this.nowScrollTop > this.aScreenTopArr[this.nowIndex + 1]) {
            //     //             this.isActive = [];
            //     //             this.nowIndex++;
            //     //             this.isActive[this.nowIndex] = true
            //     //         }
            //     //     } else if (touch.clientY > this.downY) {
            //     //         if (this.nowScrollTop < this.aScreenTopArr[this.nowIndex]) {
            //     //             this.isActive = [];
            //     //             this.nowIndex--;
            //     //             this.isActive[this.nowIndex] = true
            //     //         }
            //     //     }
            //     //
            //     // }, 4)
            // }, false)

        },
        eMoveHandle(touch) {},
        activeHandle(){
            this.isActive=[]
            this.nowIndex = 0;
            for (var i = 0; i < this.aScreenTopArr.length; i++) {
                this.isActive.push(false)
                if (this.nowScrollTop > this.aScreenTopArr[i]) {
                    this.nowIndex++
                }
            }
            this.nowIndex--;
            this.nowIndex = this.nowIndex < 0 ? 0 : this.nowIndex;
            this.isActive[this.nowIndex] = true
        },
        letterHandle(index) {
            // console.log(index,'index');
            let nowTop = this.aScreenTopArr[index] > this.maxDis ? this.maxDis : this.aScreenTopArr[index]
            this.isClickLetter=false;
            this.nowIndex=index;
            this.isActive=[];
            for (var i = 0; i < this.aScreenTopArr.length; i++) {
                this.isActive.push(false)
            }
            this.isActive[index] = true;
            window.scrollTo(0, nowTop);
        }
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?3ff2bc28